module.exports = __webpack_public_path__ + "static/img/kid-3.03c753e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kid-3.png
// module id = xuSl
// module chunks = 0